import produce from "immer";
import { DndNumberActions } from ".";
import { LoadState } from "../../constants/enums";
import { IStoreState } from "../initialStoreState";
import {
    CLEAR_DND_NUMBER_DATA_STATE,
    FETCH_DND_NUMBER_DATA_FAILURE,
    FETCH_DND_NUMBER_DATA_PROGRESS,
    FETCH_DND_NUMBER_DATA_SUCCESS,
    FETCH_SINGLE_DND_NUMBER_DATA_FAILURE,
    FETCH_SINGLE_DND_NUMBER_DATA_PROGRESS,
    FETCH_SINGLE_DND_NUMBER_DATA_SUCCESS,
    INSERT_DND_NUMBER_DATA_PROGRESS,
    INSERT_DND_NUMBER_DATA_SUCCESS,
    INSERT_DND_NUMBER_DATA_FAILURE
} from "./dnd-number.action";
import { DndNumberDataInitialState } from "./dnd-number.state";

export const dndNumberReducer = (
      state: IStoreState["dndNumber"] = DndNumberDataInitialState,
    action: DndNumberActions
) => {
    switch (action.type) {
        case FETCH_DND_NUMBER_DATA_PROGRESS: {
            const newState = produce(state, (draftState) => {
                draftState.list.loading = LoadState.InProgress;
                draftState.list.data = [];
                draftState.list.totalRecords = 0;
                draftState.list.currentRecords = 0;
                draftState.list.currentPage = 1;
                draftState.list.itemsPerPage = 10;
                draftState.list.totalPages = 0;
            });
            return newState;
        }
        case FETCH_DND_NUMBER_DATA_SUCCESS: {
            const { data, totalRecords, currentRecords, currentPage, itemsPerPage, totalPages } = action.payload;
            const newState = produce(state, (draftState) => {
                draftState.list.loading = LoadState.Loaded;
                draftState.list.data = data;
                draftState.list.totalRecords = totalRecords;
                draftState.list.currentRecords = currentRecords;
                draftState.list.currentPage = currentPage;
                draftState.list.itemsPerPage = itemsPerPage;
                draftState.list.totalPages = totalPages;
            });
            return newState;
        }
        case FETCH_DND_NUMBER_DATA_FAILURE: {
            const newState = produce(state, (draftState) => {
                draftState.list.loading = LoadState.Failed;
                draftState.list.error = action.payload;
            });
            return newState;
        }
        case FETCH_SINGLE_DND_NUMBER_DATA_PROGRESS: {
            const newState = produce(state, (draftState) => {
                draftState.dndNumberData.loading = LoadState.InProgress;
            });
            return newState;
        }
        case FETCH_SINGLE_DND_NUMBER_DATA_SUCCESS: {
            const newState = produce(state, (draftState) => {
                draftState.dndNumberData.loading = LoadState.Loaded;
                draftState.dndNumberData.data = action.payload;
            });
            return newState;
        }
        case FETCH_SINGLE_DND_NUMBER_DATA_FAILURE: {
            const newState = produce(state, (draftState) => {
                draftState.dndNumberData.loading = LoadState.Failed;
                draftState.dndNumberData.error = action.payload;
            });
            return newState;
        }
        case INSERT_DND_NUMBER_DATA_PROGRESS: {
            const newState = produce(state, (draftState) => {
                draftState.dndNumberData.loading = LoadState.InProgress;
            });
            return newState;
        }
        case INSERT_DND_NUMBER_DATA_SUCCESS: {
            const newState = produce(state, (draftState) => {
                draftState.dndNumberData.loading = LoadState.Loaded;
                draftState.dndNumberData.data = action.payload;
            });
            return newState;
        }
        case INSERT_DND_NUMBER_DATA_FAILURE: {
            const newState = produce(state, (draftState) => {
                draftState.dndNumberData.loading = LoadState.Failed;
                draftState.dndNumberData.error = action.payload;
            });
            return newState;
        }
        case CLEAR_DND_NUMBER_DATA_STATE: {
            return DndNumberDataInitialState;
        }
        default: {
            return state;
        }
    }
};
